/*
 * @Description: 接口的版本号及相关公用设置
 * @Author: gao shuai
 * @Date: 2020-02-25 15:38:30
 * @LastEditTime: 2020-09-29 08:52:39
 * @LastEditors: gao shuai
 */

export const version = 1; // 接口的版本

export const url = process.env.NODE_ENV !== 'production' ? 'http://localhost:5003/' : 'VUE_APP_TENANT_URL'; // 接口的ip__zx固定
export const netUrl = process.env.NODE_ENV !== 'production' ? 'http://localhost:5002' : 'VUE_APP_MANAGE_URL'; // 网关接口地址
export const loginUrl = process.env.NODE_ENV !== 'production' ? 'http://localhost:5004' : 'VUE_APP_SERVER_URL'; // 5004
export const authUrl = process.env.NODE_ENV !== 'production' ? 'http://localhost:5000' : 'VUE_APP_AUTH_URL'; // 5000
